import { render, staticRenderFns } from "./pagination_links.vue?vue&type=template&id=6d560896"
import script from "./pagination_links.vue?vue&type=script&lang=js"
export * from "./pagination_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports